import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import trackList from './components/tracklist/trackListReducer'
import album from './pages/album/albumReducers'
import track from './pages/track/trackReducer'
import artist from './pages/artist/artistReducer'
import playlist from './pages/playlist/playlistReducers'
import focus from './pages/focus/focusReducers'
import share from './components/share/shareReducer'
import notifierReducer from './components/notifier/NotifierReducer'
import { intlReducer } from 'react-intl-redux'
import player from './components/miniPlayer/miniPlayerReducers'
import { loading } from './components/loader/loaderReducer'
import { redirectMobile } from './redirectmobile/redirectMobileReducer'


const pages = combineReducers({
	album,
	track,
	artist,
	playlist,
	focus
})

const rootReducer = combineReducers({
	pages,
	trackList,
	routing,
	share,
	player,
	loading,
	redirectMobile,
	notifications: notifierReducer(),
	intl: intlReducer,
	form: formReducer     // <---- Mounted at 'form'
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers.js